export default __webpack_public_path__ + "static/noel_above_fold2-28e1d7fb20702de8bc0c7e89580181ef.webp";